interface EvalBarProps {
  /** 0..1, beyazın kazanma olasılığı */
  wpWhite: number;
}

export function EvalBar({ wpWhite }: EvalBarProps) {
  const pct = Math.max(0, Math.min(100, wpWhite * 100));
  return (
    <div className="evalbar" aria-label={`beyazın kazanma olasılığı %${Math.round(pct)}`}>
      <div className="evalbar-white" style={{ height: `${pct}%` }} />
      <span className="evalbar-label">{Math.round(pct)}</span>
    </div>
  );
}
